<template>
  <div class="c-box__container">
    <div class="c-box">
      <div class="c-box__content">
        <img class="c-box__icon" :src="'static/tempAssets/icon'+number+'.svg'" alt />
        <h1 class="c-box__title">{{title}}</h1>
        <div class="c-box__hexagon">
             <img :src="'static/tempAssets/fir-ball-'+number+'.svg'" alt="" srcset="">
          <span class="c-box__hexagon-title">{{number}}</span>
        </div>
      </div>
    </div>
    <img src="static/tempAssets/path-2.png" alt class="c-box__strand" v-if="number<4" />
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    number: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/mixins";

.c-box__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  @include lg {
    flex-direction: row;
  }
  &:nth-child(even) {
    .c-box__strand {
      transform: rotate(270deg);
      @include lg {
        transform: rotate(180deg);
      }
    }
    .c-box__hexagon {
      right: -27px;
      left: auto;
      @include lg {
        left: -27px;
        right: auto;
      }
    }
    .c-box {
      @include lg {
        margin-top: 2rem;
      }
    }
  }
  &:nth-child(odd) {
    .c-box {
      @include lg {
        margin-bottom: 2rem;
      }
    }
  }
}
.c-box__content {
  position: relative;
  box-shadow: 0 0 30px 0 rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  display: flex;
  flex-direction: column;
  text-align: center;
  margin: 2rem 2rem;
    min-width: 281px;
  @include md {
    min-width: 350px;
    height: 200px;
  }
  @include lg {
    max-width: 171px;
    margin: 2rem 0;
    min-width: 0;
    height: 250px;
  }
  @include xl {
    max-width: 220px;
    height: 225px;
  }
}

.c-box__icon {
  padding: 1rem;
  padding-top: 2rem;
}

.c-box__title {
  font-size: 16px;
  padding: 2rem;
  padding-top: 1rem;
}

.c-box__hexagon {
  position: absolute;
  display: flex;
  bottom: -14px;
  left: -27px;
  font-size: 1.3rem;
  background: transparent;
  font-weight: 600;
  color: white;
  width: 58px;
  height: 58px;
  text-align: center;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
}

.c-box__hexagon-title {
  position: absolute;
  font-weight: 400;
  color: white;
}

.c-box__strand {
  align-self: center;
  transform: rotate(90deg);
  @include lg {
    transform: rotate(0deg);
  }
}
</style>